import Event from "../../types/Event";
import DB_PATH from "../DB_PATH";
import { uploadMedia } from "../media/cloudflareMedia";
import { saveEventViaCallable } from "./eventLinks";

// The cover upload stays client side because it needs the browser File object.
// The document write itself goes through the adminSaveEvent callable so a gated
// event's links move to the protected subdoc instead of the public doc.
export default async ({ event }: { event: Event }) => {
  const payload: any = { ...event };

  const image = payload.imagecoverURL;
  if (image) {
    const filePath = `${DB_PATH.EVENT}/product/${image.name}`;
    const uploaded = await uploadMedia({
      body: image,
      kind: "image",
      fileName: image.name,
      firebasePath: filePath,
      onProgress: (fraction) =>
        console.log(`Upload is ${Math.round(fraction * 100)}% done`),
    });
    payload.coverURL = uploaded.url;
  }
  delete payload.imagecoverURL;
  delete payload.image;

  // The form could not load the stored links, so the two inputs hold empty
  // strings that mean nothing. Sending them would read as a deliberate clear
  // and would destroy the stored link. Absent fields make the planner keep it.
  if (!payload.protectedLinksLoaded) {
    delete payload.meetingURL;
    delete payload.replayURL;
  }
  delete payload.protectedLinksLoaded;

  return saveEventViaCallable({ event: payload, notify: false });
};
